import { useNavigate } from 'react-router'
import { Helmet } from 'react-helmet'
import { APP } from '@/common/strings'
import { APP_ROUTES } from '@/common/constants'
import { analytics } from '@/common/analytics/analytics'
import { ANALYTICS_EVENTS } from '@/common/analytics/events'
import { ONBOARDING_COPY } from '@/locales/en'
import { useEffect } from 'react'
import useUserStore from '@/user/userStore'
import { MobileVerifyForm } from './features/mobile-verify/components/MobileVerifyForm'
import { useMobileVerifyLogic } from './features/mobile-verify/useMobileVerifyLogic'
import { useOnboardingProgress } from './useOnboardingProgress'

export function MobileVerifyPage() {
    const navigate = useNavigate()
    const { progress } = useOnboardingProgress()
    const { user } = useUserStore()
    const { otp, setOtp, resendTimer, resent, error, isVerifying, isSuccess, handleResend, handleSubmit } =
        useMobileVerifyLogic()

    // Guard: redirect if user.mobile is missing
    useEffect(() => {
        if (!user?.mobile) {
            if (window.innerWidth < 640) {
                navigate(APP_ROUTES.MOBILE_NUMBER)
                return
            }

            navigate(APP_ROUTES.ABOUT_YOU)
        }
    }, [user?.mobile, navigate])

    // Navigate to survey on success
    useEffect(() => {
        if (!isSuccess) return
        navigate(APP_ROUTES.SURVEY)
    }, [isSuccess, navigate])

    const handleBack = () => {
        analytics.trackWithDefaults(ANALYTICS_EVENTS.ONBOARDING.VERIFICATION_BACK)
        if (window.innerWidth < 640) {
            navigate(APP_ROUTES.MOBILE_NUMBER)
            return
        }

        navigate(APP_ROUTES.ABOUT_YOU)
    }

    return (
        <>
            <Helmet>
                <title>
                    {ONBOARDING_COPY.MobileVerification.pageTitle} | {APP.title}
                </title>
            </Helmet>
            <MobileVerifyForm
                progress={progress}
                mobile={user?.mobile}
                otp={otp}
                resendTimer={resendTimer}
                resent={resent}
                error={error}
                loading={isVerifying}
                onSubmit={handleSubmit}
                onBack={handleBack}
                onOtpChange={setOtp}
                onResend={handleResend}
            />
        </>
    )
}
